import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { faFile, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, CircularProgress, styled, } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import api from "../../services/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../../components/footer/footer";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
const Profile = () => {
    const [nomeFile, setNomeFile] = useState("");
    const [selectedFile, setSelectedFile] = useState();
    const [loading, setLoading] = useState(false);
    const [getFiles, setGetFiles] = useState(true);
    const [urlImage, setUrlImage] = useState("");
    const { user, backGroundColor, orgaoAUsar } = useContext(UserContext);
    useEffect(() => {
        if (getFiles && user.orderNo) {
            api
                .get("/brasao", {
                params: {
                    cliente: user.orderNo,
                },
            })
                .then((response) => {
                setUrlImage(response.data);
                setLoading(false);
                setGetFiles(false);
            });
        }
    }, [getFiles, user.orderNo]);
    const handleUpload = () => {
        // Create an object of formData
        const formData = new FormData();
        // Update the formData object
        if (selectedFile !== undefined) {
            formData.append("file", selectedFile);
        }
        setLoading(true);
        // Request made to the backend api
        // Send formData object
        api
            .post("/brasao", formData, {
            params: {
                orderNo: user.orderNo,
            },
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
            .then(() => {
            toast.success("Upload de Brasão feita com sucesso", { draggablePercent: 60 });
            setSelectedFile(undefined);
            setLoading(false);
            setGetFiles(true);
        })
            .catch((error) => {
            toast.error(error, { draggablePercent: 60 });
        });
    };
    const VisuallyHiddenInput = styled("input") `
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    white-space: nowrap;
    width: 1px;
  `;
    return (_jsxs("div", { className: `page ${backGroundColor ? 'highContrast' : ''}`, children: [_jsx("div", { role: "presentation", style: { margin: "auto" }, children: _jsxs(Breadcrumbs, { "aria-label": "breadcrumb", children: [_jsx(Link, { underline: "hover", color: "inherit", href: "/", children: "Home" }), _jsx(Link, { underline: "hover", color: "inherit", href: "/manutencao", children: "Manuten\u00E7\u00E3o" }), _jsx(Typography, { color: "text.primary", children: "Bras\u00E3o" })] }) }), _jsx(ToastContainer, { draggable: true }), _jsxs("div", { className: "card__parent", children: [_jsx("div", { className: "title", children: _jsx("p", { children: `Brasão ${user.name}` }) }), _jsxs("div", { className: "", style: {
                            margin: "auto",
                            textAlign: "center",
                            paddingTop: "10px",
                            height: "50px",
                            color: "#31708f",
                            backgroundColor: "#d9edf7",
                            borderColor: "#bce8f1",
                            width: "50%",
                            display: `${selectedFile ? "none" : ""}`,
                            marginBottom: "10px",
                        }, children: [_jsx("strong", { children: "Informa\u00E7\u00E3o" }), " ", _jsx("br", {}), "Selecione um arquivo para realizar o upload!"] }), _jsxs("div", { className: "flex__firstRow", style: { display: "flex", flexDirection: "row", marginBottom: "20px", margin: "auto" }, children: [_jsxs("div", { className: "firstRow__field ", style: { marginTop: 20, marginLeft: 20 }, children: [_jsxs(Button, { component: "label", variant: "contained", href: "#file-upload", children: [_jsx(FontAwesomeIcon, { icon: faFile, style: { marginRight: 7 } }), "Selecione a imagem do Bras\u00E3o", _jsx(VisuallyHiddenInput, { type: "file", onChange: (e) => {
                                                    if (e.target && e.target instanceof HTMLInputElement && e.target.files) {
                                                        const file = e.target.files[0];
                                                        setSelectedFile(file);
                                                        setNomeFile(file.name);
                                                        setUrlImage(URL.createObjectURL(file));
                                                    }
                                                } })] }), _jsx("p", { style: { marginTop: 2 }, children: nomeFile })] }), _jsx("div", { className: "modal__brasao", children: _jsx("img", { alt: "bras\u00E3o", src: urlImage, className: "modal__brasao" }) })] }), _jsxs("div", { className: "flexRow", style: { display: "flex", flexDirection: "row", margin: "auto" }, children: [_jsx("div", { className: "button", style: { marginTop: 20, marginLeft: 20 }, children: _jsxs(Button, { variant: "contained", disabled: nomeFile === "" || selectedFile === undefined, onClick: handleUpload, children: [_jsx(FontAwesomeIcon, { icon: faUpload }), _jsx("span", { className: "p10_left", children: "salvar" })] }) }), loading && _jsxs(_Fragment, { children: [_jsx(CircularProgress, {}), " ", _jsx("p", { className: "search__check ", style: { paddingLeft: "15px", fontSize: "15px" }, children: "Esta consulta pode demorar alguns minutos" })] })] })] }), _jsx(Footer, {})] }));
};
export default Profile;
